import { reskinStyles } from 'core/components/theme/theme-variant';
import { THEME_VARIANTS } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    justifyContent: 'unset',
    gap: theme.spacing(4)
  },
  button: {
    fontSize: 12,
    padding: 0,
    fontWeight: 'normal',
    minWidth: 'unset',
    height: 'unset',
    // Sits on the dark policy-picker card, where the standard accent is too dark to read.
    color: theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colors.action_text : theme.onCard.orange_on_dark,
    ...reskinStyles(theme, theme.actionStyles.link)
  },
  switchLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    color: theme.onCard.white
  },
  disabled: {
    color: theme.onCard.beige_50_op_60
  }
});

export default makeStyles(styles);
